<ng-container *ifScreenSize="screenSize.Mobile">
  <fgb-page-header
    [pageTitle]="'wallet.redeemed.title'"
    [backButtonLink]="'/rewards/wallet'"
    [showBalance]="false"
  ></fgb-page-header>
</ng-container>
<div class="container">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="page-padding">
      <a class="cursor-pointer wallet-back-button mb-3" [routerLink]="'/rewards/wallet'">
        <span class="icon material-symbols-outlined text-white"> arrow_back_ios_new </span>
      </a>
    </div>
  </ng-container>

  <!-- Items history -->
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <h5 class="m-0 wallet-redeemed-title text-uppercase font-size-18 pb-2 pt-lg-2">
        {{ 'wallet.redeemed.item.history.title' | translate }}
      </h5>
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [style]="'list'"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="container">
    <div class="border rounded bg-white">
      <div class="font-size-12 text-center py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
